import escapeStringRegexp from './escape-string-regexp';

export const highlight = (text, terms) => {
  let fragments = [text || ''];

  for (const term of terms
    .split(' ')
    .map((v) => v.trim())
    .filter(Boolean)) {
    fragments = fragments.flatMap((fragment) => {
      if (typeof fragment === 'string') {
        const regex = new RegExp(escapeStringRegexp(term), 'gi');

        let count = 0;
        let cursor = 0;
        const parts = [];

        // eslint-disable-next-line no-constant-condition
        while (true) {
          const match = regex.exec(fragment);
          count++;
          if (!match) {
            const prev = fragment.substring(cursor, fragment.length);
            prev && parts.push(prev);
            break;
          }

          if (count > 100) {
            console.error('emergency stop');
            break;
          }

          const matchIndex = match.index;
          const prev = fragment.substring(cursor, matchIndex);
          prev && parts.push(prev);
          const current = fragment.substring(
            matchIndex,
            matchIndex + term.length
          );
          parts.push({ term: current });
          cursor = matchIndex + term.length;
        }
        return parts;
      } else {
        return fragment;
      }
    });
  }

  return fragments
    .map((fragment) =>
      typeof fragment === 'string'
        ? fragment
        : `<strong>${fragment.term}</strong>`
    )
    .join('');
};

////// FUUZZZZZZ ALDRINNNN!!

//
// Score similarity between two string
//
//  isMatch: Fast detection if all character of needle is in haystack
//  score: Find string similarity using a Smith Waterman algorithm
//         Modified to account for programing scenarios (CamelCase folder/file.ext object.property)
//
// Copyright (C) 2015 Jean Christophe Roy and contributors
// MIT License: http://opensource.org/licenses/MIT

// Base point for a single character match
// This balance making patterns VS position and size penalty.

const wm = 150;

//Fading function
const pos_bonus = 20; // The character from 0..pos_bonus receive a greater bonus for being at the start of string.
const tau_size = 150; // Full path length at which the whole match score is halved.

// Miss count
// When subject[i] is query[j] we register a hit.
// Limiting hit put a boundary on how many permutation we consider to find the best one.
// Helps to speed-up processing of long path and query containing frequent character (eg vowels)
//
// If a spec with frequent repetition fail, increase this.
// This has a direct influence on worst case scenario benchmark.
const miss_coeff = 0.75; //Max number missed consecutive hit = ceil(miss_coeff*query.length) + 5

//
// Main export
//
// Manage the logic of testing if there's a match and calling the main scoring function
// Also manage scoring a path and optional character.

const scorePreparedQuery = function (string, preparedQuery, allowErrors) {
  if (
    !allowErrors &&
    !isMatch(string, preparedQuery.core_lw, preparedQuery.core_up)
  ) {
    return 0;
  }
  const string_lw = string.toLowerCase();
  const score = computeScore(string, string_lw, preparedQuery);
  return Math.ceil(score);
};

//
// isMatch:
// Are all (non optional)characters of query in subject, in proper order ?
//

const isMatch = function (subject, query_lw, query_up) {
  const m = subject.length;
  const n = query_lw.length;

  if (!m || n > m) {
    return false;
  }

  let i = -1;
  let j = -1;

  //foreach char of query
  while (++j < n) {
    const qj_lw = query_lw.charCodeAt(j);
    const qj_up = query_up.charCodeAt(j);

    // continue walking the subject from where we have left with previous query char
    // until we have found a character that is either lowercase or uppercase query.
    while (++i < m) {
      const si = subject.charCodeAt(i);
      if (si === qj_lw || si === qj_up) {
        break;
      }
    }

    // if we passed the last char, query is not in subject
    if (i === m) {
      return false;
    }
  }

  //Found every char of query in subject in proper order, match is positive
  return true;
};

//----------------------------------------------------------------------
//
// Main scoring algorithm
//

const computeScore = function (subject, subject_lw, preparedQuery) {
  let score;
  const { query } = preparedQuery;
  const { query_lw } = preparedQuery;

  const m = subject.length;
  const n = query.length;

  //----------------------------
  // Exact Match ?
  // => use that as score

  const pos = subject_lw.indexOf(query_lw);
  if (pos > -1) {
    return scoreExactMatch(subject, subject_lw, query, query_lw, pos, n, m);
  }

  //----------------------------
  // Individual characters
  // (Smith Waterman algorithm)

  // Init
  const score_row = new Array(n);
  const csc_row = new Array(n);
  const sz = scoreSize(n, m);

  const miss_budget = Math.ceil(miss_coeff * n) + 5;
  let miss_left = miss_budget;
  let csc_should_rebuild = true;

  // Fill with 0
  let j = -1;
  while (++j < n) {
    score_row[j] = 0;
    csc_row[j] = 0;
  }

  let i = -1;
  while (++i < m) {
    //foreach char si of subject
    const si_lw = subject_lw[i];

    // if si_lw is not in query
    if (!(si_lw.charCodeAt(0) in preparedQuery.charCodes)) {
      // reset csc_row and move to next subject char
      // unless we just cleaned it then keep cleaned version.
      if (csc_should_rebuild) {
        j = -1;
        while (++j < n) {
          csc_row[j] = 0;
        }
        csc_should_rebuild = false;
      }
      continue;
    }

    score = 0;
    let score_diag = 0;
    let csc_diag = 0;
    let record_miss = true;
    csc_should_rebuild = true;

    j = -1; //0..n-1
    while (++j < n) {
      //foreach char qj of query

      // What is the best gap ?
      // score_up contain the score of a gap in subject.
      // score_left = last iteration of score, -> gap in query.
      const score_up = score_row[j];
      if (score_up > score) {
        score = score_up;
      }

      //Reset consecutive
      let csc_score = 0;

      //Compute a tentative match
      if (query_lw[j] === si_lw) {
        const start = isWordStart(i, subject, subject_lw);

        // Forward search for a sequence of consecutive char
        csc_score =
          csc_diag > 0
            ? csc_diag
            : scoreConsecutives(
                subject,
                subject_lw,
                query,
                query_lw,
                i,
                j,
                start
              );

        // Determine bonus for matching A[i] with B[j]
        const align = score_diag + scoreCharacter(i, j, start, csc_score);

        //Are we better using this match or taking the best gap (currently stored in score)?
        if (align > score) {
          score = align;
          // reset consecutive missed hit count
          miss_left = miss_budget;
        } else {
          // We rejected this match and record a miss.
          // If budget is exhausted exit
          // Each character of query have it's score history stored in score_row
          // To get full query score use last item of row.
          if (record_miss && --miss_left <= 0) {
            return Math.max(score, score_row[n - 1]) * sz;
          }

          record_miss = false;
        }
      }

      //Prepare next sequence & match score.
      score_diag = score_up;
      csc_diag = csc_row[j];
      csc_row[j] = csc_score;
      score_row[j] = score;
    }
  }

  // get hightest score so far
  score = score_row[n - 1];
  return score * sz;
};

//
// Boundaries
//
// Is the character at the start of a word, end of the word, or a separator ?
// Fortunately those small function inline well.
//

const isWordStart = function (pos, subject, subject_lw) {
  if (pos === 0) {
    return true;
  } // match is FIRST char ( place a virtual token separator before first char of string)
  const curr_s = subject[pos];
  const prev_s = subject[pos - 1];
  return (
    isSeparator(prev_s) || // match FOLLOW a separator
    (curr_s !== subject_lw[pos] && prev_s === subject_lw[pos - 1])
  ); // match is Capital in camelCase (preceded by lowercase)
};

const isWordEnd = function (pos, subject, subject_lw, len) {
  if (pos === len - 1) {
    return true;
  } // last char of string
  const curr_s = subject[pos];
  const next_s = subject[pos + 1];
  return (
    isSeparator(next_s) || // match IS FOLLOWED BY a separator
    (curr_s === subject_lw[pos] && next_s !== subject_lw[pos + 1])
  ); // match is lowercase, followed by uppercase
};

const isSeparator = (c) =>
  c === ' ' || c === '.' || c === '-' || c === '_' || c === '/' || c === '\\';

//
// Scoring helper
//

const scorePosition = function (pos) {
  if (pos < pos_bonus) {
    const sc = pos_bonus - pos;
    return 100 + sc * sc;
  } else {
    return Math.max(100 + pos_bonus - pos, 0);
  }
};

const scoreSize = (
  n,
  m // Size penalty, use the difference of size (m-n)
) => tau_size / (tau_size + Math.abs(m - n));

const scoreExact = (n, m, quality, pos) =>
  2 * n * (wm * quality + scorePosition(pos)) * scoreSize(n, m);

//
// Shared scoring logic between exact match, consecutive & acronym
// Ensure pattern length dominate the score then refine to take into account case-sensitivity
// and structural quality of the pattern on the overall string (word boundary)
//

const scorePattern = function (count, len, sameCase, start, end) {
  let sz = count;

  let bonus = 6; // to ensure consecutive length dominate score, this should be as large other bonus combined
  if (sameCase === count) {
    bonus += 2;
  }
  if (start) {
    bonus += 3;
  }
  if (end) {
    bonus += 1;
  }

  if (count === len) {
    // when we match 100% of query we allow to break the size ordering.
    // This is to help exact match bubble up vs size, depth penalty etc
    if (start) {
      if (sameCase === len) {
        sz += 2;
      } else {
        sz += 1;
      }
    }
    if (end) {
      bonus += 1;
    }
  }

  return sameCase + sz * (sz + bonus);
};

//
// Compute the bonuses for two chars that are confirmed to matches in a case-insensitive way
//

const scoreCharacter = function (i, j, start, csc_score) {
  // start of string / position of match bonus
  const posBonus = scorePosition(i);

  // match IS a word boundary
  if (start) {
    return posBonus + wm * (csc_score + 10);
  }

  // normal Match
  return posBonus + wm * csc_score;
};

//
// Forward search for a sequence of consecutive character.
//

const scoreConsecutives = function (
  subject,
  subject_lw,
  query,
  query_lw,
  i,
  j,
  startOfWord
) {
  const m = subject.length;
  const n = query.length;

  const mi = m - i;
  const nj = n - j;
  const k = mi < nj ? mi : nj;

  let sameCase = 0;
  let sz = 0; //sz will be one more than the last qi is sj

  // query_lw[i] is subject_lw[j] has been checked before entering now do case sensitive check.
  if (query[j] === subject[i]) {
    sameCase++;
  }

  //Continue while lowercase char are the same, record when they are case-sensitive match.
  while (++sz < k && query_lw[++j] === subject_lw[++i]) {
    if (query[j] === subject[i]) {
      sameCase++;
    }
  }

  // If we quit because of a non match
  // replace cursor to the last match
  if (sz < k) {
    i--;
  }

  // Faster path for single match.
  // Isolated character match occurs often and are not really interesting.
  // Fast path so we don't compute expensive pattern score on them.
  if (sz === 1) {
    return 1 + 2 * sameCase;
  }

  return scorePattern(
    sz,
    n,
    sameCase,
    startOfWord,
    isWordEnd(i, subject, subject_lw, m)
  );
};

//
// Compute the score of an exact match at position pos.
//

const scoreExactMatch = function (
  subject,
  subject_lw,
  query,
  query_lw,
  pos,
  n,
  m
) {
  // Test for word start
  let start = isWordStart(pos, subject, subject_lw);

  // Heuristic
  // If not a word start, test next occurrence
  // - We want exact match to be fast
  // - For exact match, word start has the biggest impact on score.
  // - Testing 2 instances is somewhere between testing only one and testing every instances.

  if (!start) {
    const pos2 = subject_lw.indexOf(query_lw, pos + 1);
    if (pos2 > -1) {
      start = isWordStart(pos2, subject, subject_lw);
      if (start) {
        pos = pos2;
      }
    }
  }

  //Exact case bonus.
  let i = -1;
  let sameCase = 0;
  while (++i < n) {
    if (query[pos + i] === subject[i]) {
      sameCase++;
    }
  }

  const end = isWordEnd(pos + n - 1, subject, subject_lw, m);

  return scoreExact(n, m, scorePattern(n, n, sameCase, start, end), pos);
};

let preparedQueryCache = null;

const opt_char_re = /[ _\-:/\\]/g;

const coreChars = function (query, optCharRegEx) {
  if (optCharRegEx == null) {
    optCharRegEx = opt_char_re;
  }
  return query.replace(optCharRegEx, '');
};

const truncatedUpperCase = function (str: string) {
  let upper = '';
  for (const char of Array.from(str)) {
    upper += char.toUpperCase()[0];
  }
  return upper;
};

//
// Get character codes:
// --------------------
//
// Get character codes map for a given string
//

const getCharCodes = function (str) {
  const len = str.length;
  let i = -1;

  const charCodes = [];
  // create map
  while (++i < len) {
    charCodes[str.charCodeAt(i)] = true;
  }

  return charCodes;
};

class Query {
  query;
  query_lw;
  core;
  core_lw;
  core_up;
  charCodes;

  constructor(query, optCharRegEx) {
    if (!query || !query.length) {
      return null;
    }

    this.query = query;
    this.query_lw = query.toLowerCase();
    this.core = coreChars(query, optCharRegEx);
    this.core_lw = this.core.toLowerCase();
    this.core_up = truncatedUpperCase(this.core);
    this.charCodes = getCharCodes(this.query_lw);
  }
}

export const score = (
  string,
  query,
  allowErrors = false,
  optCharRegEx = null
) => {
  if (
    !(string != null ? string.length : undefined) ||
    !(query != null ? query.length : undefined)
  ) {
    return 0;
  }

  const preparedQuery =
    preparedQueryCache && preparedQueryCache.query === query
      ? preparedQueryCache
      : (preparedQueryCache = new Query(query, optCharRegEx));

  return scorePreparedQuery(string, preparedQuery, allowErrors);
};
